<ng-container *ngIf="!scope.config.disableRegisterPage; else showNoAccessMsg">
  <app-embedded-toolbar (onConfigure)="scope.openConfiguration()"
    [configurationName]="scope.translations.REGISTER_CONFIG"></app-embedded-toolbar>

  <div class="register-hero">
    <div class="register-hero__inner">
      <h1 class="register-hero__title">
        <ng-container *ngIf="scope.opportunity">Your Info</ng-container>
        <ng-container *ngIf="!scope.opportunity">{{scope.getText | transform:'REGISTER_NOW'}}</ng-container>
      </h1>
    </div>
  </div>

  <div class="register-body">
    <div class="register-card" *ngIf="scope.wizard">
      <app-error-summary [error]="scope.error" *ngIf="scope.error"></app-error-summary>
      <div [ngSwitch]="(scope.status | async)" [@inOutAnimation]>
        <ng-container *ngSwitchDefault [ngTemplateOutlet]="PENDING"></ng-container>
        <ng-container *ngSwitchCase="'LOADING'" [ngTemplateOutlet]="LOADING"></ng-container>
        <ng-container *ngSwitchCase="'COMPLETED'" [ngTemplateOutlet]="COMPLETED"></ng-container>
        <ng-container *ngSwitchCase="'REGISTERED'" [ngTemplateOutlet]="REGISTERED"></ng-container>
        <div class="register-card__actions">
            <button class="register-card__login-btn" mat-stroked-button [routerLink]="['/login']">{{scope.getText | transform:'ALREADY_REGISTERED?'}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #PENDING>
  <div class="register-card__upload">
    <div>
      <h2 class="register-card__heading"
        [innerText]="scope.getText | transform:'UPLOAD_YOUR_RESUME':{resumeOrCv: resumeOrCvText}"></h2>
      <p class="register-card__text" [innerText]="scope.getText | transform:'WE_WILL_PREFILL_YOUR_INFORMATION'"></p>
    </div>
    <div class="register-card__upload-field">
      <app-upload-file (uploadEvent)="scope.resumeUpload($event)" id="resume-upload" class="app-upload-file" disabledDiv></app-upload-file>
    </div>
  </div>
</ng-template>

<ng-template #LOADING>
  <div class="register-card__upload">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    <span tabindex="0">{{scope.loadStatus}}</span>
  </div>
</ng-template>

<ng-template #COMPLETED>
  <app-dynamic-form-wizard [groups]="scope.wizard" [groupValidators]="scope.groupValidators" (submit)="scope.register($event)"></app-dynamic-form-wizard>
</ng-template>

<ng-template #REGISTERED>
  <div>
    <h2 class="register-card__heading" [innerText]="scope.getText | transform:'SUCCESS'"></h2>
    <p class="register-card__text" [innerText]="scope.getText | transform:'CHECK_YOUR_EMAIL'"></p>
  </div>
</ng-template>

<ng-template #showNoAccessMsg>
  <div class="register-hero">
    <div class="register-hero__inner">
      <h1 class="register-hero__title">{{scope.getText | transform:'PAGE_NO_ACCESS_MSG'}}</h1>
    </div>
  </div>
</ng-template>